import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {MatPaginator as MatPaginator, PageEvent as PageEvent } from "@angular/material/paginator";
import {MatTableDataSource as MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject, of } from "rxjs";
import { switchMap, take, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.css"],
})
export class NotificationsComponent implements OnInit ,OnDestroy {
  displayedColumns: string[] = [
    "Email",
    "CreatedBy",
    "Phone",
    "CreatedOn",
    "Title",
    "Severity",
    // "Topics",
    "Type",
    "Action",
  ];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>([]);
  dataLength: any;
  index: number = 0;
  size: number = 10;
  params: any = {};
  notifyTitle: any = "";
  notificationName: any = "";
  createdBy: any = "";
  Email: any = "";
  public modalRef: BsModalRef;
  notifyData: any = {};
  fromDate: any;
  toDate: any;
  severityId: any=-1;
  topicId: any;
  typeId: any= -1;
  Phone;
  isInbox: boolean;
  totalLength: any;
  destroyPage$=new Subject()
  constructor(
    private httpClient: HttpClient,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.destroyPage$)).subscribe(async (param) => {
      this.isInbox = param.notficationInbox ? true : false;

      if (this.isInbox) {
        this.getNotificationInbox();
      } else {
        this.getAllNotification();
      }
    });
  }

  getAllNotification(params = null) {
    if (params) {
      this.params = params;
    } else {
      this.params = {
        Pagination: { Start: this.index, Number: this.size },
        Search: {
          PredicateObject:
            {
              Name: this.notifyTitle || null,
              NotificationName: this.notificationName || null,
              Email: this.Email || null,
              CreatedBy: this.createdBy || null,
              Severity: this.severityId==-1?null:this.severityId || null,
              Topic: this.topicId || null,
              Type: this.typeId==-1?null:this.typeId || null,
              Phone: this.Phone || null,
              CreatedOn:
                {
                  before: this.toDate
                    ? new Date(this.toDate).toLocaleDateString()
                    : null,
                  after: this.fromDate
                    ? new Date(this.fromDate).toLocaleDateString()
                    : null,
                } || null,
            } 
        },
        Sort: {},
      };
    }
    this.httpClient
      .post(`/Notification/quick-search`, this.params)
      .subscribe((res: any) => {
        res.data.forEach((element) => {
          element.data = JSON.parse(element.data);
        });
        this.dataSource = new MatTableDataSource(res.data);
        this.dataLength = res.totalCount;
        if (params) {
          this.index = 0;
        }
      });
  }

  changePage(event: PageEvent) {
    this.index = event.pageIndex;
    this.size = event.pageSize;


    if (this.isInbox) {
      this.getNotificationInbox();
    } else {
      this.getAllNotification();
    }
  }

  applyFilter() {
    this.params = {
      Pagination: { Start: 0, Number: this.size },
      Search: {
        PredicateObject:
          {
            //Email:this.Email|| null ,
            Name: this.notifyTitle || null,
            NotificationName: this.notificationName || null,
            Email: this.Email || null,
            CreatedBy: this.createdBy || null,
            Severity: this.severityId==-1?null:this.severityId || null,
            Topic: this.topicId || null,
            Type: this.typeId==-1?null:this.typeId || null,
            Phone: this.Phone || null,
            CreatedOn:
              {
                before: this.toDate
                  ? new Date(this.toDate).toLocaleDateString()
                  : null,
                after: this.fromDate
                  ? new Date(this.fromDate).toLocaleDateString()
                  : null,
              } || null,
          } 
      },
      Sort: {},
    };
  

    if (this.isInbox) {
      this.getNotificationInbox(this.params);
    } else {
      this.getAllNotification(this.params);
    }
  }

  getNotificationInbox(params?) {
    if (params) {
      this.params = params;
      this.params.Search.PredicateObject.Type="PushNotification"
    } else {
      this.params = {
        Pagination: { Start: this.index, Number: this.size },
        Search: {
          PredicateObject:
            {
              Name: this.notifyTitle || null,
              NotificationName: this.notificationName || null,
              Email: this.Email || null,
              CreatedBy: this.createdBy || null,
              Severity: this.severityId==-1?null:this.severityId || null,
              Topic: this.topicId || null,
              Type: "PushNotification",
              Phone: this.Phone || null,
              CreatedOn:
                {
                  before: this.toDate
                    ? new Date(this.toDate).toLocaleDateString()
                    : null,
                  after: this.fromDate
                    ? new Date(this.fromDate).toLocaleDateString()
                    : null,
                } || null,
            } || null,
        },
        Sort: {},
      };
    }
    this.httpClient
      .post<any>("/Notification/GetNotificationsForWeb", this.params)

      .pipe(
        switchMap((res: any) => {
          res.data.forEach((ele) => {
            ele.title = ele.data ? JSON.parse(ele.data).Title : "";
            ele.message = ele.data ? JSON.parse(ele.data).Message : "";
          });
          return of(res);
        })
      )
      .subscribe((res) => {
        console.log(res);

        this.dataSource = new MatTableDataSource<any>(res.data);
        this.totalLength = res.totalRecords;
      });
  }
  showMessageDetails(data, template: TemplateRef<any>) {
    this.notifyData = data;
    this.modalRef = this.modalService.show(template, {
      class: "modal-dialog-centered",
    });
  }
  ngOnDestroy(  ){
    this.destroyPage$?this.destroyPage$.next(true):null
  }
}
